import { PhoneNumberUtil } from "google-libphonenumber";
import { z } from "zod";

export const e164PhoneRegex = /^\+46\d{7,10}$/;

const phoneUtil = PhoneNumberUtil.getInstance();

export function normalizeToE164(phone: string): string {
  const cleaned = phone.replace(/[\s\-.\(\)]/g, "");

  if (cleaned.startsWith("+46")) return cleaned;
  if (cleaned.startsWith("0046")) return `+46${cleaned.slice(4)}`;
  if (cleaned.startsWith("46") && cleaned.length >= 11) return `+${cleaned}`;
  if (cleaned.startsWith("0")) return `+46${cleaned.slice(1)}`;

  return cleaned;
}

export function isValidSwedishPhone(value: string): boolean {
  const normalized = normalizeToE164(value);
  if (!e164PhoneRegex.test(normalized)) return false;
  try {
    return phoneUtil.isValidNumber(phoneUtil.parse(normalized, "SE"));
  } catch {
    return false;
  }
}

export const contactDetailsSchema = z.object({
  email: z.string().email("Ange en giltig e-postadress"),
  phoneNumber: z
    .string()
    .min(1, "Ange ett telefonnummer")
    .refine(isValidSwedishPhone, "Ange ett giltigt svenskt telefonnummer"),
});

export type ContactDetails = z.infer<typeof contactDetailsSchema>;

export function validateEmail(value: string) {
  return contactDetailsSchema.shape.email.safeParse(value).success;
}

export function validatePhone(value: string) {
  return contactDetailsSchema.shape.phoneNumber.safeParse(value).success;
}
